import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    //-----市/区管理-----//
    placeList(level) {
        return interfaceAjax({
            url: '/admin/place/list',
            method: 'post',
            data: {level}
        });
    },
    addPlace(data) {
        return interfaceAjax({
            url: "/admin/place/add",
            data
        });
    },
    updatePlace(data) {
        return interfaceAjax({
            url: "/admin/place/update",
            data
        });
    },
    detailPlace(id) {
        return interfaceAjax({
            url: '/admin/place/detail',
            data:{id}
        });
    },
    deletePlace(id) {
        return interfaceAjax({
            url: '/admin/place/delete',
            data: {id}
        });
    },
    //-----组织管理-----//
    departList(params, data) {
        return interfaceAjax({
            url: '/admin/depart/list',
            params,
            data:{
                ...data,
                departmentType:0
            }
        });
    },
    departExamList(params, data) {
        return interfaceAjax({
            url: '/admin/depart/list',
            params:{
                ...params,

            },
            data:{
                ...data,
                departmentType:1
            }
        });
    },
    departAdd(data) {
        return interfaceAjax({
            url: '/admin/depart/add',
            data
        });
    },
    departUpdate(data) {
        return interfaceAjax({
            url: '/admin/depart/update',
            data
        });
    },
    departDelete(id) {
        return interfaceAjax({
            url: '/admin/depart/delete',
            data:{id}
        });
    },
    departUpdateAuth(data) {
        return interfaceAjax({
            url: '/admin/depart/updateAuth',
            data
        });
    },
    //-----人员管理-----//
}
